import React from 'react';
import './Benefits.css';
import { BenefitCard } from './BenefitCard';
import imgResults from '../../../../images/lp/googleV2/HP-valueprop1.webp';
import imgTreatments from '../../../../images/lp/googleV2/benefits_3.webp';
import imgSafe from '../../../../images/lp/googleV2/benefits_4.webp';
import imgInvestment from '../../../../images/lp/googleV2/benefits_2.webp';

const defaultBenefits = [
    {
        title: (
            <>
                Permanent results<sup>1</sup>
            </>
        ),
        subtitle: 'Targets hair at the root for lasting results',
        image: imgResults,
    },
    { title: 'Unlimited treatments', subtitle: 'Pay once, stay smooth for life', image: imgTreatments },
    { title: 'Safe for every skin tone', subtitle: 'Advanced laser tech, medically supervised', image: imgSafe },
    { title: 'Smarter investment', subtitle: 'Never waste time shaving or waxing again', image: imgInvestment },
];

const header = 'Why clients trust Milan';
const subheader =
    "Milan Laser's licensed medical professionals follow treatment protocols to deliver the safest treatments and most effective results in laser hair removal.";

export function Benefits({ items = defaultBenefits }) {
    return (
        <section className="googlelp-benefits googlelp-container text-center flex flex-column align-center pt-5">
            <div className="googlelp-benefits-container pb-4 pb-md-5">
                <h2 className="mcl-font-greycliff pb-0 mb-0">{header}</h2>
                <p className="googlelp-benefits-subheader mcl-font-proxima mb-0 py-3 px-0 italic">"{subheader}"</p>
                <p className="googlelp-doctor-name googlelp-doctor mcl-font-proxima mb-0 font-bold">
                    -Dr. Nate Haecker, MD, MBA
                </p>
                <p className="googlelp-doctor mcl-font-proxima mb-0">Chief Medical Officer</p>
            </div>

            <div className="googlelp-benefits-grid grid grid-cols-1 gap-4 gap-md-5 mx-auto">
                {items.map((it, i) => (
                    <BenefitCard
                        key={i}
                        title={it.title as string}
                        subtitle={it.subtitle as string}
                        image={it.image as string}
                        alt={it.title as string}
                    />
                ))}
            </div>
        </section>
    );
}

export default Benefits;
